import axios from "axios";
import { Loader } from "@googlemaps/js-api-loader";
import { getStoreCategories, isFullRangeStore, STORE_CATEGORIES } from "../store-materials.js";

const url = window.location.origin;
const MAP_CONFIG = {
  zoom: 10,
  disableDefaultUI: true,
  center: { lat: 55.676098, lng: 12.568337 },
  mapId: "563f50d500c53a0b",
};

// State
let mapDesktop;
let geocoder;
let userLatitude;
let userLongitude;
let mapMarkesDesktop = [];

// DOM elements
const storeWrapper = document.querySelector(".store__store-list-wrapper");
const storeMessage = document.querySelector(".store__nearest-store-message");
const inputSearchStore = document.querySelector("#store-search-input");
const storeCountElement = document.querySelector(".store__store-list-title span");

// Pin SVGs
const pinFullRange = `<svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 24 24' fill='none'> <g clip-path='url(#clip0_1722_14351)'> <circle cx='12' cy='9' r='3' fill='#F8F7EE'/> <path d='M18 9.5C18 6.19 15.31 3.5 12 3.5C8.69 3.5 6 6.19 6 9.5C6 14 12 20.5 12 20.5C12 20.5 18 14 18 9.5ZM10 9.5C10 8.4 10.9 7.5 12 7.5C13.1 7.5 14 8.4 14 9.5C14 10.6 13.11 11.5 12 11.5C10.9 11.5 10 10.6 10 9.5Z' fill='#CC6633'/> </g> <defs> <clipPath id='clip0_1722_14351'> <rect width='24' height='24' fill='white'/> </clipPath> </defs> </svg>`;
const pinDefault = `<svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 24 24' fill='none'> <g clip-path='url(#clip0_1564_8498)'> <circle cx='12' cy='9' r='3' fill='#F8F7EE'/> <path d='M18 9.5C18 6.19 15.31 3.5 12 3.5C8.69 3.5 6 6.19 6 9.5C6 14 12 20.5 12 20.5C12 20.5 18 14 18 9.5ZM10 9.5C10 8.4 10.9 7.5 12 7.5C13.1 7.5 14 8.4 14 9.5C14 10.6 13.11 11.5 12 11.5C10.9 11.5 10 10.6 10 9.5Z' fill='#27303E'/> </g> <defs> <clipPath id='clip0_1564_8498'> <rect width='24' height='24' fill='white'/> </clipPath> </defs> </svg>`;

// Clear existing markers from map
let clearMarkers = () => {
  mapMarkesDesktop.forEach((marker) => (marker.map = null));
  mapMarkesDesktop = [];
};

// Fetch stores
let getStores = async (count, lat, lng) => {
  clearMarkers();

  let storeResults = { products: [], distance: [] };

  try {
    const response = await axios.get(
      `${url}/google/maps/distance/${count}/${lat}/${lng}`,
    );
    storeResults = response.data;
  } catch (err) {
    console.log(err);
    return [];
  }

  if (storeResults.products.length === 0) {
    return [];
  }

  const distanceMap = new Map(
    storeResults.distance.map((d) => [d.id, d.distance]),
  );

  return storeResults.products
    .map((store) => ({
      ...store,
      distance: Math.round(distanceMap.get(store.id) || 0),
    }))
    .filter((store) => store.distance <= 100)
    .sort((a, b) => a.distance - b.distance);
};

let closeAllStorCard = () => {
  document.querySelectorAll(".store-tag--dropdown").forEach((e) => {
    e.classList.remove("open");
  });
};

let openStorCard = (id) => {
  const mediaQuery = window.matchMedia("(min-width: 768px)");
  document.getElementById(id).classList.add("open");

  setTimeout(() => {
    if (mediaQuery.matches) {
      document.querySelector(".store__store-list-wrapper").scrollTo({
        behavior: "smooth",
        top: document.querySelector(
          `.store__store-list-wrapper .store-tag--dropdown[id="${id}"]`,
        ).offsetTop,
      });
    } else {
      document.getElementById(id).scrollIntoView();
    }
  }, 600);
};

// Create marker element
let createMarker = (store) => {
  const isFullRange = isFullRangeStore(store.material);
  const parser = new DOMParser();
  const pinSvg = parser.parseFromString(
    isFullRange ? pinFullRange : pinDefault,
    "image/svg+xml",
  ).documentElement;

  return new google.maps.marker.AdvancedMarkerElement({
    map: mapDesktop,
    position: {
      lat: Number(store.latitude),
      lng: Number(store.longtitude),
    },
    content: pinSvg,
    title: store.id.toString(),
  });
};

// RenderPin
let renderPin = (listStores) => {
  listStores.forEach((store) => {
    mapMarkesDesktop.push(createMarker(store));
  });

  document.querySelectorAll(".store-tag--dropdown").forEach((btn) => {
    btn.addEventListener("mouseenter", (e) => {
      const el = document.querySelector(
        `div[title="${Number(e.currentTarget.id)}"]`,
      );
      if (el) el.classList.add("bounce-pin");
      mapDesktop.panTo(
        new google.maps.LatLng(
          Number(e.currentTarget.dataset.latitude),
          Number(e.currentTarget.dataset.longtitude),
        ),
      );
    });

    btn.addEventListener("mouseleave", (e) => {
      const el = document.querySelector(
        `div[title="${Number(e.currentTarget.id)}"]`,
      );
      if (el) el.classList.remove("bounce-pin");
    });
  });

  mapMarkesDesktop.forEach((item) => {
    item.addListener("click", ({ domEvent }) => {
      closeAllStorCard();
      openStorCard(Number(domEvent.currentTarget.getAttribute("title")));
    });

    item.content.addEventListener("mouseover", (e) => {
      const titlePin =
        e.currentTarget.parentElement.parentElement.getAttribute("title");
      const el = document.querySelector(`div[title="${Number(titlePin)}"]`);
      if (el) el.classList.add("bounce-pin");
    });

    item.content.addEventListener("mouseout", (e) => {
      const titlePin =
        e.currentTarget.parentElement.parentElement.getAttribute("title");
      const el = document.querySelector(`div[title="${Number(titlePin)}"]`);
      if (el) el.classList.remove("bounce-pin");
    });
  });
};

// Build material items HTML
let renderMaterialItems = (storeMaterial) =>
  STORE_CATEGORIES
    .map(
      (name) =>
        `<div class="store-tag__bottom-material-item ${getStoreCategories(storeMaterial).includes(name) ? "" : "disabled"}">${name}</div>`,
    )
    .join("");

// Shop data is imported from an external source we cannot edit, and a few
// records arrive as ALL CAPS or all lowercase. Only those are normalised —
// their original casing is lost anyway, so nothing can be broken by it.
// Mixed-case values are left alone: "Odense SØ", "Rte de la Coula 50".
let normalizeCase = (value) => {
  const text = String(value ?? "");
  const isUniformCase =
    text === text.toLocaleUpperCase() || text === text.toLocaleLowerCase();

  if (!isUniformCase) return text;

  return text
    .toLocaleLowerCase()
    .replace(/\p{L}[\p{L}\p{M}'’]*/gu, (word) =>
      word.replace(/^./u, (letter) => letter.toLocaleUpperCase()),
    );
};

// Render stores
let renderStores = (listStores) => {
  storeWrapper.innerHTML = "";
  listStores.forEach((store) => {
    const isFullRange = isFullRangeStore(store.material);
    storeWrapper.insertAdjacentHTML(
      "beforeend",
      `
      <div class="store-tag store-tag--dropdown ${isFullRange ? "store-tag--full-range" : ""}" data-latitude="${store.latitude}" data-longtitude="${store.longtitude}" id="${store.id}">
        <div class="store-tag__wrapper">
            <div class="store-tag__top">
                <div class="store-tag__address">
                    <span class="store-tag__address-title">${store.name}</span>
                    <span class="store-tag__address-street">${normalizeCase(store.address)},</span>
                    <span class="store-tag__address-state">${normalizeCase(store.city)} ${store.postcode}</span>
                    ${
                      isFullRange
                        ? `<div class="store-tag__full-range">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0 6C0 4.4087 0.632141 2.88258 1.75736 1.75736C2.88258 0.632141 4.4087 0 6 0C7.5913 0 9.11742 0.632141 10.2426 1.75736C11.3679 2.88258 12 4.4087 12 6C12 7.5913 11.3679 9.11742 10.2426 10.2426C9.11742 11.3679 7.5913 12 6 12C4.4087 12 2.88258 11.3679 1.75736 10.2426C0.632141 9.11742 0 7.5913 0 6H0ZM6 2.8C6.07606 2.79997 6.15055 2.82164 6.21474 2.86244C6.27893 2.90325 6.33015 2.96151 6.3624 3.0304L7.136 4.68L8.86 4.944C8.9326 4.9552 9.00071 4.98617 9.05687 5.03352C9.11303 5.08087 9.15507 5.14277 9.17838 5.21243C9.20168 5.28209 9.20535 5.35683 9.18898 5.42844C9.17262 5.50005 9.13685 5.56577 9.0856 5.6184L7.8272 6.9088L8.1256 8.736C8.13774 8.81016 8.12875 8.88623 8.09965 8.95552C8.07055 9.0248 8.02252 9.08448 7.96107 9.12773C7.89962 9.17098 7.82723 9.19605 7.7522 9.20006C7.67716 9.20406 7.60251 9.18686 7.5368 9.1504L6 8.3L4.4632 9.1504C4.39743 9.18693 4.32269 9.20416 4.24756 9.20013C4.17243 9.1961 4.09997 9.17096 4.03848 9.1276C3.977 9.08425 3.92899 9.02443 3.89996 8.95502C3.87094 8.88561 3.86208 8.80942 3.8744 8.7352L4.1728 6.9088L2.9136 5.6184C2.86211 5.56575 2.82616 5.4999 2.8097 5.42811C2.79324 5.35633 2.79693 5.2814 2.82034 5.21157C2.84375 5.14175 2.88599 5.07974 2.94239 5.03239C2.99879 4.98503 3.06718 4.95417 3.14 4.9432L4.8632 4.68L5.6376 3.0304C5.66985 2.96151 5.72107 2.90325 5.78526 2.86244C5.84945 2.82164 5.92394 2.79997 6 2.8Z" fill="#CC6633"/>
                        </svg>
                        <span class="store-tag__full-range-text">Full Range Store</span>
                    </div>`
                        : ""
                    }
                </div>

                <div class="store-tag__info">
                    <div class="store-tag__info-distance">
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" fill="none">
                            <path d="M8 4.33301C8 2.12634 6.20667 0.333008 4 0.333008C1.79333 0.333008 0 2.12634 0 4.33301C0 7.33301 4 11.6663 4 11.6663C4 11.6663 8 7.33301 8 4.33301ZM2.66667 4.33301C2.66667 3.59967 3.26667 2.99967 4 2.99967C4.73333 2.99967 5.33333 3.59967 5.33333 4.33301C5.33333 5.06634 4.74 5.66634 4 5.66634C3.26667 5.66634 2.66667 5.06634 2.66667 4.33301Z" fill="#27303E"/>
                        </svg>
                        <span class="store-tag__info-distance-text">${store.distance}km</span>
                    </div>
                    <a href="https://www.google.com/maps/dir/?api=1&origin=${userLatitude},${userLongitude}&destination=${store.latitude},${store.longtitude}&travelmode=driving" target="_blank" class="store-tag__info-direction">Direction</a>
                </div>
            </div>

            <div class="store-tag__bottom">
                <span class="store-tag__bottom-title">Product range available</span>
                <div class="store-tag__bottom-material">
                    ${renderMaterialItems(store.material)}
                </div>

                <ul class="store-tag__bottom-info">
                    ${store.internet_address !== null ? '<li><span class="store-tag__bottom-info-title">Website:</span><a href="https://' + store.internet_address + '" target="_blank">' + store.internet_address + "</a><li/>" : ""}
                    ${store.telephone !== null ? '<li><span class="store-tag__bottom-info-title">Phone:</span><a href="tel:' + store.telephone + '">' + store.telephone + "</a><li/>" : ""}
                </ul>
            </div>

            <button type="button" class="store-tag__button">
                <span>See Details</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="5" viewBox="0 0 8 5" fill="none">
                    <path d="M0 0.5L3.50376 4.5L4.49624 4.5L8 0.5L6.82707 0.5L3.98496 3.78358L1.15789 0.5L0 0.5Z" fill="#3F4753"/>
                </svg>
            </button>
        </div>
    </div>`,
    );
  });
};

// Handle search results and update map
let handleStoreResults = (response, lat, lng, inputContainer) => {
  userLatitude = lat;
  userLongitude = lng;

  if (inputContainer) {
    inputContainer.classList.remove("input--show-results");
  }

  if (response.length !== 0) {
    storeMessage.setAttribute("style", "display: none;");
    storeCountElement.textContent = response.length;
    renderStores(response);
    renderPin(response);
    mapDesktop.setCenter(
      new google.maps.LatLng(
        Number(response[0].latitude),
        Number(response[0].longtitude),
      ),
    );
  } else {
    storeCountElement.textContent = "0";
    storeMessage.setAttribute("style", "display: block;");
    storeMessage.textContent = "No shops were found within 100 km.";
    storeWrapper.innerHTML = "";
    mapDesktop.setCenter(new google.maps.LatLng(lat, lng));
  }
};

// Country name in its own language ("DK" -> "Danmark"), Google returns it in English
let localizedCountry = (component) => {
  if (!component) return null;

  try {
    const language = new Intl.Locale(`und-${component.short_name}`).maximize()
      .language;
    const displayName = new Intl.DisplayNames([language], {
      type: "region",
    }).of(component.short_name);

    return displayName || component.long_name;
  } catch (err) {
    return component.long_name;
  }
};

// Google's formatted_address repeats the building/POI name ("Søkvæsthuset,
// Søkvæsthuset, Overgaden Oven Vandet 58A, ..."), so build the address ourselves
let formatAddress = (result) => {
  const component = (type) =>
    (result.address_components || []).find((item) => item.types.includes(type));

  // Keep Google's own country-specific ordering ("58A" after the street in DK,
  // before it in the UK) by checking which variant its formatted_address uses
  const ordered = (first, second) => {
    if (!first) return second ? second.long_name : null;
    if (!second) return first.long_name;

    const formatted = result.formatted_address || "";
    const isReversed = [second.long_name, second.short_name].some(
      (secondName) =>
        [first.long_name, first.short_name].some((firstName) =>
          formatted.includes(`${secondName} ${firstName}`),
        ),
    );

    return isReversed
      ? `${second.long_name} ${first.long_name}`
      : `${first.long_name} ${second.long_name}`;
  };

  const route = component("route");
  const city = component("locality") || component("postal_town");
  if (!route && !city) return result.formatted_address;

  return [
    route && ordered(route, component("street_number")),
    city && ordered(component("postal_code"), city),
    localizedCountry(component("country")),
  ]
    .filter(Boolean)
    .join(", ");
};

// Find stores — autocomplete
const inputAutoComplete = document.querySelector(".input-search--store input");
const inputContainerElement = document.querySelector(
  ".input-search--store .input-search__autocomplete",
);
const inputResetButton = document.querySelector(
  ".input-search--store .input-search__reset",
);

let renderAutocompleteList = (results) => {
  inputContainerElement.querySelector("ul").innerHTML = "";
  if (results.length !== 0) {
    results.forEach((itemResult) => {
      const lat =
        typeof itemResult.geometry.location.lat === "function"
          ? itemResult.geometry.location.lat()
          : itemResult.geometry.location.lat;
      const lng =
        typeof itemResult.geometry.location.lng === "function"
          ? itemResult.geometry.location.lng()
          : itemResult.geometry.location.lng;
      inputContainerElement.querySelector("ul").insertAdjacentHTML(
        "beforeend",
        `<li class="get-address" data-lat="${lat}" data-lng="${lng}">${formatAddress(itemResult)}</li>`,
      );
    });
  } else {
    inputContainerElement.querySelector("ul").insertAdjacentHTML(
      "beforeend",
      `<li class="not-found">No address found</li>`,
    );
  }
};

// Address click handler
document.addEventListener("click", (e) => {
  const addressEl = e.target.closest(".get-address");
  if (!addressEl) return;

  const lat = addressEl.dataset.lat;
  const lng = addressEl.dataset.lng;
  const inputContainer = addressEl.parentNode.closest(".input");

  inputSearchStore.value = addressEl.textContent;

  getStores(15, lat, lng)
    .then((response) => {
      handleStoreResults(response, lat, lng, inputContainer);
    })
    .catch((err) => {
      console.log(err);
      handleStoreResults([], lat, lng, inputContainer);
    });
});

// Close autocomplete when clicking outside
document.addEventListener("click", (e) => {
  if (!e.target.closest(".input")) {
    const container = document.querySelector(".input-search--store .input");
    if (container) {
      container.classList.remove("input--show-results");
    }
  }
});

try {
  inputResetButton.addEventListener("click", (e) => {
    const inputContainer = e.currentTarget.parentNode.closest(".input");
    const inputSearchElement = inputContainer.querySelector("input");
    const autocomplete = inputContainer.querySelector(
      ".input-search__autocomplete",
    );

    inputContainer.classList.remove("input--show-results");
    inputContainer.classList.remove("input--no-empty");
    autocomplete.querySelector("ul").innerHTML = "";
    inputSearchElement.value = "";
  });

  // Input state — geocode on typing
  inputAutoComplete.addEventListener("input", (event) => {
    const input = event.currentTarget;
    const inputContainer = input.parentNode.closest(".input");
    const autocomplete = inputContainer.querySelector(
      ".input-search__autocomplete",
    );

    if (input.value.length > 1) {
      geocoder
        .geocode({ address: input.value })
        .then((response) => {
          inputContainer.classList.add("input--show-results");
          if (response.results.length > 0) {
            renderAutocompleteList(response.results);
          } else {
            autocomplete.querySelector("ul").innerHTML =
              '<li class="not-found">No address found</li>';
          }
        })
        .catch((err) => {
          console.log(err);
          autocomplete.querySelector("ul").innerHTML =
            '<li class="not-found">Error retrieving data</li>';
        });
    } else {
      inputContainer.classList.remove("input--show-results");
      autocomplete.querySelector("ul").innerHTML = "";
    }
  });

  // Focus state
  inputAutoComplete.addEventListener("focus", (event) => {
    const inputContainer = event.currentTarget.parentNode.closest(".input");
    if (event.currentTarget.value.length > 1) {
      inputContainer.classList.add("input--show-results");
    }
  });

  // Click geolocation button
  document
    .querySelector(".js-update-location")
    .addEventListener("click", () => {
      navigator.geolocation.getCurrentPosition((pos) => {
        mapDesktop.setCenter(
          new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude),
        );
      }, error);
    });
} catch (err) {
  console.log(err);
}

// Geolocation success callback
let success = (position) => {
  userLatitude = position.coords.latitude;
  userLongitude = position.coords.longitude;

  getStores(15, userLatitude, userLongitude)
    .then((response) => {
      handleStoreResults(response, userLatitude, userLongitude);
    })
    .catch((err) => {
      console.log(err);
      handleStoreResults([], userLatitude, userLongitude);
    });

  geocoder
    .geocode({ location: { lat: userLatitude, lng: userLongitude } })
    .then((response) => {
      if (response.results.length !== 0) {
        // Prefer a street-level result — results[0] is often the building/POI
        const result =
          response.results.find((item) =>
            item.types.includes("street_address"),
          ) ||
          response.results.find((item) => item.types.includes("route")) ||
          response.results[0];

        inputSearchStore.value = formatAddress(result);
      }
    })
    .catch((err) => {
      console.log(err);
    });
};

// Geolocation error callback
let error = () => {
  storeMessage.innerHTML = `To locate your nearest retailer you need to enable geolocation in your browser. <a href="https://whatismyipaddress.com/enabling-and-disabling-geolocation-on-your-browser" target="_blank">More info</a>.`;
};

// Initialize map
if (document.querySelector(".store")) {
  const loader = new Loader({
    apiKey: "AIzaSyBSTTa9ckso5eQfuOptR9LYLhwJ9-aYXpU",
    version: "quarterly",
  });

  loader.load().then(async () => {
    try {
      await google.maps.importLibrary("maps");
      await google.maps.importLibrary("marker");

      geocoder = new google.maps.Geocoder();

      mapDesktop = new google.maps.Map(
        document.getElementById("map"),
        MAP_CONFIG,
      );

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(success, error);
      } else {
        storeMessage.innerHTML = `Geolocation is not supported by your browser`;
      }
    } catch (err) {
      console.error(
        "Error loading Google Maps libraries or initializing the map:",
        err,
      );
    }
  });
}
